const environments = {
    development: {
        compositionApi: 'https://api.test-sdbleerplatform.nl/api/1.0/composition',
        ltiConsumerApi: 'https://lticonsumer.test-sdbleerplatform.nl',
        ltiProviderApi: 'https://ltiprovider.sdbleerplatform.nl',
        ltiAdvantageApi: 'https://ltiadvantage.test-sdbleerplatform.nl',
        catalogApi: 'https://app-sdblearning-test-catalog.azurewebsites.net',
        learningApi: 'https://api.test-sdbleerplatform.nl',
        compositionPlayerUrl: 'https://compositionplayer.test-sdbleerplatform.nl',
        accreditationProviderPortal: 'TCG-TEST',
    },
    production: {
        compositionApi: 'https://api.sdbleerplatform.nl/api/1.0/composition',
        ltiConsumerApi: 'https://lticonsumer.sdbleerplatform.nl',
        ltiProviderApi: 'https://ltiprovider.sdbleerplatform.nl',
        ltiAdvantageApi: 'https://ltiadvantage.sdbleerplatform.nl',
        catalogApi: 'https://catalogapi.sdbleerplatform.nl',
        learningApi: 'https://api.sdbleerplatform.nl',
        compositionPlayerUrl: 'https://compositionplayer.sdbleerplatform.nl',
        accreditationProviderPortal: 'CURSUS-REV',
    },
};

export { environments as default };
